/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Info about last months winners (derived from winner record documents).
 * @export
 * @interface WinnerSummary
 */
export interface WinnerSummary {
    /**
     * Name of the winner (user name or guild name if entire guild won)
     * @type {string}
     * @memberof WinnerSummary
     */
    winnerName: string;
    /**
     * Brand name to display on guild page
     * @type {string}
     * @memberof WinnerSummary
     */
    rewardDescription: string;
}

/**
 * Check if a given object implements the WinnerSummary interface.
 */
export function instanceOfWinnerSummary(value: object): value is WinnerSummary {
    if (!('winnerName' in value) || value['winnerName'] === undefined) return false;
    if (!('rewardDescription' in value) || value['rewardDescription'] === undefined) return false;
    return true;
}

export function WinnerSummaryFromJSON(json: any): WinnerSummary {
    return WinnerSummaryFromJSONTyped(json, false);
}

export function WinnerSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): WinnerSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'winnerName': json['winnerName'],
        'rewardDescription': json['rewardDescription'],
    };
}

export function WinnerSummaryToJSON(json: any): WinnerSummary {
    return WinnerSummaryToJSONTyped(json, false);
}

export function WinnerSummaryToJSONTyped(value?: WinnerSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'winnerName': value['winnerName'],
        'rewardDescription': value['rewardDescription'],
    };
}

